import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';

class QuizGreeting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enableAudio: props.enableAudio || false,
    };
  }

  copyState() {
    return Object.assign({}, this.state);
  }

  componentDidUpdate() {
    if (this.props.enableAudio === undefined) {
      return;
    }
    setTimeout(() => {
      const state = this.copyState();
      state.enableAudio = this.props.enableAudio;
      this.setState(state);
    }, 100);
  }

  enableAudioChanged(ev) {
    const newState = this.copyState();
    newState.enableAudio = ev.target.checked;
    this.setState(newState);
    if (this.props.enableAudioChanged) {
      this.props.enableAudioChanged(newState.enableAudio);
    }
  }

  render() {
    return (
      <div className="Login">
        {!this.props.hideTitle && <h2>
          英単語クイズ
        </h2>}
        <p>
          3分間、英単語クイズをしてみましょう！<br/>
          <br/>
          <strong>[はじめる]</strong>をタップすると、英単語が表示されます。<br/>
          4択で日本語訳の候補が表示されますので、どの訳が適切か、タップして回答してください！
        </p>
        {!this.props.hideCaution && <p class="caution">
          ※回答内容はあとでご自身の理解度の変化を把握するためのもので、成績づけや採点に利用することはありません。
        </p>}
        {!this.props.disableAudio && <p class="audio">
          <Form.Check
            type='checkbox'
            label='発音を音声で確認する'
            disabled={this.props.disableAudio}
            checked={this.state.enableAudio}
            onChange={e => this.enableAudioChanged(e)}
          />
          <br/>
          <span class="audio-caution">(スピーカー・ヘッドフォンから音が流れます)</span>
        </p>}
      </div>
    );
  }
}

export default QuizGreeting;
